'use client';

import clsx from 'clsx';
import { FC, PropsWithChildren, useEffect, useState } from 'react';

import ClientPortal from '../portal';
import styles from './styles.module.css';

interface Props {
  onClose: () => void;
  visible: boolean;
}

const ANIMATION_TIME = 0.4;

const transitionStyle = {
  transition: `opacity ${ANIMATION_TIME}`,
};

const AppModal: FC<PropsWithChildren<Props>> = ({ onClose, visible: isMounted, children }) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    setShow(isMounted);
  }, [isMounted]);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      onClose();
    }, ANIMATION_TIME * 1000);
  };

  return (
    <ClientPortal selector="modalPortal" visible={isMounted}>
      <div className={clsx(styles.container, transitionStyle, isMounted && styles.mounted, show && styles.visible)}>
        <div className={styles.background} onClick={handleClose} />
        {children}
      </div>
    </ClientPortal>
  );
};

export default AppModal;
